<template>
  <div class="call-connection-point-select-container">
    <BSelect
      v-model="selectValue"
      :items="callConnectionPoints"
      :placeholder="i18n.t('callResult.allConnectionPoints')"
      multiple
      collapse-tags
      collapse-tags-tooltip
      item-text="name"
      item-value="value"
      fit
    />
  </div>
</template>

<script setup lang="ts">
import { defineModel } from 'vue';
import { useI18n } from 'vue-i18n';
import useCallConnectionPoints from '@/composable/user/callResult/call-connection-points';

const i18n = useI18n();

const selectValue = defineModel<string[]>();
const { callConnectionPoints } = useCallConnectionPoints();
</script>

<style lang="scss" scoped>
.call-connection-point-select-container {
  width: 100%;
}
</style>
